









import mixins from 'vue-typed-mixins';
import ContactInfoUtils, {ContactInfo} from "@/utils/ContactInfoUtils";
export default mixins().extend({
  data(): {
    contactInfo?: Partial<ContactInfo>;
  } {
    return {
      contactInfo: undefined
    }
  },
  props: {
    displayKey: String
  },
  computed: {
    contactInfoHtml(): any {
      if (this.contactInfo && this.displayKey) {
        let info = undefined;
        switch(this.displayKey) {
          case 'contactLogin':
            info = this.contactInfo.contactLogin;
            break;

          case 'contactMenu':
            info = this.contactInfo.contactMenu;
            break;

          default:
            return "";
        }

        return this.$translate(info);
      }

      return "";
    }
  },
  async mounted() {
    try {
      this.contactInfo = await ContactInfoUtils.api.get();
    } catch (error) {
      this.$alert.show('mounted', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
});
